import { render } from "./Error404View.vue?vue&type=template&id=71f67414&scoped=true&ts=true"
import script from "./Error404View.vue?vue&type=script&lang=ts"
export * from "./Error404View.vue?vue&type=script&lang=ts"

import "./Error404View.vue?vue&type=style&index=0&id=71f67414&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71f67414"]])

export default __exports__